import { makeStyles } from '@material-ui/core';
import { blackColor, menuHoverBgColor } from 'assets/jss/material-dashboard-pro-react';
import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';

const useStyles = makeStyles((theme: any) => ({
	listItem: {
		fontSize: theme.fontSize(14),
		padding: 0,
		fontFamily: 'inherit',
		marginBottom: '0.25rem',

		'&:last-child': {
			marginBottom: 0,
		},

		'&:hover': {
			backgroundColor: menuHoverBgColor,
			borderRadius: '1rem',
		},
	},
	active: {
		backgroundColor: menuHoverBgColor,
		borderRadius: '1rem',
	},
	linkItem: {
		color: blackColor,
		flex: 1,
		padding: '0.75rem',
	},
}));

const SettingsMenuItem = ({ route, label, onClick }: { route: string; label: string; onClick: () => void }) => {
	const classes = useStyles();
	const location = useLocation();

	const menuClasses = classNames(classes.listItem, {
		[classes.active]: location.pathname === route,
	});

	return (
		<MenuItem className={menuClasses} onClick={onClick}>
			<Link className={classes.linkItem} to={route}>
				{label}
			</Link>
		</MenuItem>
	);
};

export default SettingsMenuItem;
